import React, { useMemo, useState, useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContainer from "../../components/Common/TableContainer"
import { getLab, deleteLab, getOneLab } from "../../service/api"
import jsPDF from "jspdf";
import "jspdf-autotable";
// import { toast } from "react-toastify";
import DeleteConfirmationModal from "./DeleteConfirmationModal"
import Preloader from "components/Preloader/Preloader";


function ViewLab() {
  const [alluserlist, setallusers] = useState({ users: [] })
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [selectedDeleteData, setSelectedDeleteData] = useState(null)
  const [loading, setLoading] = useState(true);

  // const [lab, setLab] = useState(null)
  // const { id } = useParams()

  useEffect(() => {
    getLabAll()
  }, [])

  const navigate = useNavigate()

  const getLabAll = async () => {
    try {
      let response = await getLab()
      if (response.error) {
        console.log("Error while fetching data:", response.error)
      } else {
        setallusers({ users: response.data || [] })
      }
    } catch (error) {
      console.log("Error while fetching data:", error)
    } finally {
      setLoading(false);
    }
  }


  const openViewModel = id => {
    navigate(`/LabDetails/${id}`)
  }

  const openDeleteModal = id => {
    setSelectedDeleteData(id)

    setIsDeleteModalOpen(true)
  }

  const closeDeleteModal = () => {
    setSelectedDeleteData(null)
    setIsDeleteModalOpen(false)
  }

  const handleDelete = async () => {
    try {
      if (selectedDeleteData) {
        let response = await deleteLab(selectedDeleteData)
        if (response.status === 200) {
          console.log("Deleted successfully", response)
          // Uncomment this line if you want to show a toast message
          // toast.success("Patient deleted successfully.", { position: "top-center", autoClose: 1500 });
          closeDeleteModal()
          getLabAll()
        } else {
          console.log("Error deleting patient")
        }
      }
    } catch (error) {
      console.error("Error while deleting Lab Order:", error)
    }
  }

  const THEME_RGB = [220, 76, 100];
  const API_URL = process.env.REACT_APP_MYAPI_URL || "";

  const loadImgAsBase64 = (url) => new Promise((resolve) => {
    if (!url) return resolve(null);
    fetch(url, { credentials: "omit" })
      .then(r => r.ok ? r.blob() : null)
      .then(blob => {
        if (!blob) return resolve(null);
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => resolve(null);
        reader.readAsDataURL(blob);
      })
      .catch(() => resolve(null));
  });

  const handleDownloadPDF = async (id) => {
    let lab;
    try {
      const res = await getOneLab(id);
      lab = res.data;
    } catch { return; }

    const doc = new jsPDF();
    const pageW = doc.internal.pageSize.width;
    const pageH = doc.internal.pageSize.height;
    const margin = 12;
    const contentW = pageW - margin * 2;
    let y = margin;

    const checkPage = (need = 20) => {
      if (y + need > pageH - margin) { doc.addPage(); y = margin; }
    };

    const headStyles = { fillColor: THEME_RGB, textColor: [255, 255, 255], fontStyle: "bold", fontSize: 9, cellPadding: 3 };
    const lbStyle = { fontStyle: "bold", textColor: [100, 100, 100], fontSize: 7.5, fillColor: [248, 248, 248], cellPadding: 2.5 };
    const valStyle = { fontStyle: "normal", textColor: [20, 20, 20], fontSize: 9, fillColor: [255, 255, 255], cellPadding: 2.5 };
    const tblStyles = { lineColor: [220, 220, 220], lineWidth: 0.15 };
    const tblOpts = { margin: { left: margin, right: margin }, tableWidth: contentW, tableLineColor: [200, 200, 200], tableLineWidth: 0.2 };
    const lv = (label, value) => [{ content: label, styles: lbStyle }, { content: String(value || "—"), styles: valStyle }];
    const col4 = { 0: { cellWidth: 30 }, 1: { cellWidth: contentW / 2 - 30 }, 2: { cellWidth: 30 }, 3: { cellWidth: contentW / 2 - 30 } };

    const clinic = lab.patient_id?.patientID?.clinicname;
    const patient = lab.patient_id?.patientID;

    // ── Letterhead: Logo + Clinic info (left) | Title (right) ──
    const logoPath = clinic?.logo ? clinic.logo.split("/").pop() : null;
    const logoUrl = logoPath ? `${API_URL}/uploads/${logoPath}` : null;
    const logoData = logoUrl ? await loadImgAsBase64(logoUrl) : null;

    const headerStartY = y;
    let leftY = headerStartY;

    // Logo on top-left
    if (logoData) {
      const maxLogoH = 18, maxLogoW = 50;
      const img = new Image();
      img.src = logoData;
      await new Promise(r => { img.onload = r; img.onerror = r; });
      const ratio = img.width && img.height ? Math.min(maxLogoW / img.width, maxLogoH / img.height) : 1;
      const lw = img.width ? img.width * ratio : maxLogoW;
      const lh = img.height ? img.height * ratio : maxLogoH;
      doc.addImage(logoData, "JPEG", margin, leftY, lw, lh);
      leftY += lh + 3;
    }

    // Clinic name + details below logo on left
    if (clinic?.name) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor(30, 30, 30);
      doc.text(clinic.name, margin, leftY);
      leftY += 5;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(100, 100, 100);
      if (clinic.address) { doc.text(clinic.address, margin, leftY); leftY += 4; }
      if (clinic.city || clinic.province) {
        doc.text([clinic.city, clinic.province].filter(Boolean).join(", "), margin, leftY);
        leftY += 4;
      }
      if (clinic.contactno) { doc.text(`Tel: ${clinic.contactno}`, margin, leftY); leftY += 4; }
      if (clinic.email) { doc.text(clinic.email, margin, leftY); leftY += 4; }
    }

    // "External Lab" title on right
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    doc.setTextColor(...THEME_RGB);
    doc.text("External Lab", pageW - margin, headerStartY + 10, { align: "right" });
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8.5);
    doc.setTextColor(140, 140, 140);
    doc.text("Lab Order Document", pageW - margin, headerStartY + 16, { align: "right" });

    y = Math.max(leftY, headerStartY + 22) + 4;
    doc.setDrawColor(...THEME_RGB);
    doc.setLineWidth(0.6);
    doc.line(margin, y, pageW - margin, y);
    y += 5;

    // ── Order Info ──
    doc.autoTable({
      startY: y,
      head: [[{ content: "Order Information", colSpan: 4, styles: headStyles }]],
      body: [
        [...lv("Order No.", lab.order_no), ...lv("Date", lab.date)],
        [...lv("Order Type", lab.order_type), ...lv("Practice Name", lab.practisc_name)],
        [...lv("Patient Name", lab.patient_name), ...lv("VC Reference", lab.vc_reference)],
      ],
      columnStyles: col4, styles: tblStyles, ...tblOpts,
    });
    y = doc.lastAutoTable.finalY + 4;

    // ── Practice Details ──
    if (clinic) {
      doc.autoTable({
        startY: y,
        head: [[{ content: "Practice Details", colSpan: 4, styles: headStyles }]],
        body: [
          [...lv("Practice Name", clinic.name), ...lv("Email", clinic.email)],
          [...lv("Contact No.", clinic.contactno), ...lv("Address", clinic.address)],
          [...lv("City", clinic.city), ...lv("Province", clinic.province)],
        ],
        columnStyles: col4, styles: tblStyles, ...tblOpts,
      });
      y = doc.lastAutoTable.finalY + 4;
    }

    // ── Patient Details ──
    if (patient) {
      doc.autoTable({
        startY: y,
        head: [[{ content: "Patient Details", colSpan: 4, styles: headStyles }]],
        body: [
          [...lv("Full Name", lab.patient_name), ...lv("MPI No.", patient.mpino)],
          [...lv("Date of Birth", patient.dob), ...lv("Age", patient.age?.toString())],
          [...lv("Gender", patient.gender), ...lv("Contact", patient.mobile)],
        ],
        columnStyles: col4, styles: tblStyles, ...tblOpts,
      });
      y = doc.lastAutoTable.finalY + 4;
    }

    // ── Frame Details ──
    doc.autoTable({
      startY: y,
      head: [[{ content: "Frame Details", colSpan: 4, styles: headStyles }]],
      body: [
        [...lv("Frame", lab.frame), ...lv("Brand", lab.frame_brand)],
        [...lv("Color", lab.frame_color), ...lv("Size", lab.frame_size)],
        [...lv("Material", lab.frame_material), ...lv("Type", lab.frame_type)],
        [...lv("Shape", lab.frame_shape), ...lv("PD", lab.pd)],
        [...lv("PD Left", lab.pd_left), ...lv("PD Right", lab.pd_right)],
      ],
      columnStyles: col4, styles: tblStyles, ...tblOpts,
    });
    y = doc.lastAutoTable.finalY + 4;

    // ── Prescription ──
    const rxColW = contentW / 6;
    doc.autoTable({
      startY: y,
      head: [[
        { content: "Prescription", styles: headStyles },
        { content: "Sphere", styles: headStyles },
        { content: "Cyl", styles: headStyles },
        { content: "Axis", styles: headStyles },
        { content: "Add", styles: headStyles },
        { content: "Seg Height", styles: headStyles },
      ]],
      body: [
        [
          { content: "OD [Right]", styles: { ...lbStyle, textColor: THEME_RGB } },
          { content: lab.od_spere || "—", styles: valStyle },
          { content: lab.od_cyl || "—", styles: valStyle },
          { content: lab.od_axis || "—", styles: valStyle },
          { content: lab.od_add || "—", styles: valStyle },
          { content: lab.od_seg_height || "—", styles: valStyle },
        ],
        [
          { content: "OS [Left]", styles: { ...lbStyle, textColor: [91, 155, 213] } },
          { content: lab.os_spere || "—", styles: valStyle },
          { content: lab.os_cyl || "—", styles: valStyle },
          { content: lab.os_axis || "—", styles: valStyle },
          { content: lab.os_add || "—", styles: valStyle },
          { content: lab.os_seg_height || "—", styles: valStyle },
        ],
      ],
      columnStyles: { 0: { cellWidth: rxColW }, 1: { cellWidth: rxColW }, 2: { cellWidth: rxColW }, 3: { cellWidth: rxColW }, 4: { cellWidth: rxColW }, 5: { cellWidth: rxColW } },
      styles: tblStyles, ...tblOpts,
    });
    y = doc.lastAutoTable.finalY + 4;

    // ── Lens Details (OD + OS side by side) ──
    const halfW = contentW / 2 - 2;
    const lensLabelW = 28, lensValW = halfW - lensLabelW;

    checkPage(40);
    doc.autoTable({
      startY: y,
      head: [[
        { content: "Lens — OD (Right Eye)", colSpan: 2, styles: { ...headStyles, fillColor: THEME_RGB } },
        { content: "Lens — OS (Left Eye)", colSpan: 2, styles: { ...headStyles, fillColor: [91, 155, 213] } },
      ]],
      body: [
        [...lv("Material", lab.lens_material_od || lab.lens_material), ...lv("Material", lab.lens_material_os || lab.lens_material)],
        [...lv("Vision Type", lab.lens_vision_od?.vision || lab.lens_vision?.vision), ...lv("Vision Type", lab.lens_vision_os?.vision || lab.lens_vision?.vision)],
        // [...lv("Sub-Type", lab.lens_subvision_od?.sub_type || lab.lens_subvision?.sub_type), ...lv("Sub-Type", lab.lens_subvision_os?.sub_type || lab.lens_subvision?.sub_type)],
        [...lv("Coating", lab.lens_type_od || lab.lens_type), ...lv("Coating", lab.lens_type_os || lab.lens_type)],
        [...lv("Photochromic", (lab.extra_od || lab.extra) === "yes" ? "Yes" : "No"), ...lv("Photochromic", (lab.extra_os || lab.extra) === "yes" ? "Yes" : "No")],
      ],
      columnStyles: { 0: { cellWidth: lensLabelW }, 1: { cellWidth: lensValW }, 2: { cellWidth: lensLabelW }, 3: { cellWidth: lensValW } },
      styles: tblStyles, ...tblOpts,
    });
    y = doc.lastAutoTable.finalY + 6;

    // ── Frame Image + Signature side by side ──
    const frameImgData = lab.frame_image || null; // already base64
    const sigPath = lab.signature ? lab.signature.split("/").pop() : null;
    const sigData = sigPath ? await loadImgAsBase64(`${API_URL}/uploads/${sigPath}`) : null;

    const hasImage = frameImgData || sigData;
    if (hasImage) {
      checkPage(55);

      // Section label
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.setTextColor(...THEME_RGB);

      const colW = contentW / 2 - 3;
      const maxImgH = 40;
      const maxImgW = colW;

      // Helper: draw one image block
      const drawImgBlock = (data, label, x) => {
        if (!data) return;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.setTextColor(100, 100, 100);
        doc.text(label, x, y);
        const img = new Image();
        img.src = data;
        // Use natural dimensions for aspect ratio
        const nw = img.naturalWidth || img.width || 200;
        const nh = img.naturalHeight || img.height || 100;
        const ratio = Math.min(maxImgW / nw, maxImgH / nh);
        const dw = nw * ratio, dh = nh * ratio;
        doc.addImage(data, "JPEG", x, y + 3, dw, dh);
        doc.setDrawColor(...THEME_RGB);
        doc.setLineWidth(0.3);
        doc.rect(x, y + 3, dw, dh);
      };

      drawImgBlock(frameImgData, "Frame Photo", margin);
      drawImgBlock(sigData, "Authorised Signature", margin + colW + 6);

      y += maxImgH + 10;
    }

    doc.save(`external-lab-${lab.order_no || id}.pdf`);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Sr.",
        accessor: (_row, i) => i + 1,
        id: "srno",
        Cell: ({ value }) => <span style={{ fontWeight: "600", color: "#888" }}>{value}</span>,
      },
      {
        Header: "Order No",
        accessor: "order_no",
        Cell: ({ value }) => (
          <span style={{ fontWeight: "700", color: "#DC4C64", fontFamily: "monospace" }}>{value || "—"}</span>
        ),
      },
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => value || "—",
      },
      {
        Header: "Patient",
        accessor: "patient_name",
        Cell: ({ row }) => (
          <div>
            <div style={{ fontWeight: "600", fontSize: 13 }}>{row.original.patient_name || "—"}</div>
            <div style={{ fontSize: 11, color: "#888" }}>{row.original.vc_reference || ""}</div>
          </div>
        ),
      },
      {
        Header: "Practice",
        accessor: "practisc_name",
        Cell: ({ value }) => <span style={{ fontSize: 12 }}>{value || "—"}</span>,
      },
      {
        Header: "Frame",
        accessor: "frame_brand",
        Cell: ({ row }) => {
          const o = row.original;
          if (!o.frame_brand && !o.framecode) return "—";
          return (
            <div>
              <div style={{ fontWeight: "600", fontSize: 12 }}>{o.frame_brand || "—"}</div>
              <div style={{ fontSize: 10, color: "#888" }}>{o.framecode || ""} {o.frame_color ? `· ${o.frame_color}` : ""}</div>
            </div>
          );
        },
      },
      {
        Header: "OD Rx",
        accessor: "od_spere",
        Cell: ({ row }) => {
          const o = row.original;
          if (!o.od_spere && !o.od_cyl) return "—";
          return (
            <span style={{ fontSize: 11, fontFamily: "monospace" }}>
              {o.od_spere || "0"} / {o.od_cyl || "0"} × {o.od_axis || "0"}
            </span>
          );
        },
      },
      {
        Header: "OS Rx",
        accessor: "os_spere",
        Cell: ({ row }) => {
          const o = row.original;
          if (!o.os_spere && !o.os_cyl) return "—";
          return (
            <span style={{ fontSize: 11, fontFamily: "monospace" }}>
              {o.os_spere || "0"} / {o.os_cyl || "0"} × {o.os_axis || "0"}
            </span>
          );
        },
      },
      {
        Header: "Lens",
        accessor: "lens_vision_od",
        Cell: ({ row }) => {
          const o = row.original;
          const vision = o.lens_vision_od?.vision || "—";
          const coating = o.lens_type_od || o.lens_type || "";
          const coatColors = { uc: "#6c757d", hc: "#0d6efd", hmc_blue: "#0dcaf0", shmc_blue: "#6610f2" };
          const coatLabels = { uc: "UC", hc: "HC", hmc_blue: "HMC Blue", shmc_blue: "SHMC Blue" };
          return (
            <div>
              <div style={{ fontSize: 12 }}>{vision}</div>
              {coating && (
                <span style={{ background: coatColors[coating] || "#aaa", color: "#fff", padding: "1px 7px", borderRadius: 10, fontSize: 10, fontWeight: 600 }}>
                  {coatLabels[coating] || coating}
                </span>
              )}
            </div>
          );
        },
      },
      {
        Header: "Total (R)",
        accessor: "total",
        Cell: ({ value }) => (
          <span style={{ fontWeight: "700", color: "#28a745" }}>R {value || "0"}</span>
        ),
      },
      {
        Header: "Action",
        Cell: ({ row }) => {
          const id = row.original._id
          return (
            <div style={{ display: "flex", gap: 4 }}>
              <button className="btn btn-warning btn-sm" title="View" onClick={() => openViewModel(id)}>
                <i className="mdi mdi-eye font-size-15"></i>
              </button>
              <button className="btn btn-success btn-sm" title="Download PDF" onClick={() => handleDownloadPDF(id)}>
                <i className="mdi mdi-download font-size-15"></i>
              </button>
              <button className="btn btn-danger btn-sm" title="Delete" onClick={() => openDeleteModal(id)}>
                <i className="mdi mdi-trash-can font-size-15"></i>
              </button>
            </div>
          )
        },
      },
    ],
    []
  )

  document.title = "Lab Order | List"

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="page-title">Lab Order list</h3>
            <Link to="/Addlab" className="btn btn-primary">
              ADD NEW LAB ORDER
            </Link>
          </div>
          {/* <Breadcrumbs title="Setting" breadcrumbItem="Lab Order list" /> */}
          <div>
            <TableContainer
              columns={columns}
              data={alluserlist.users}
              isGlobalFilter={true}
              isAddOptions={false}
              customPageSize={10}
              className="custom-header-css"
            />
            {loading && <Preloader />}
          </div>
          <DeleteConfirmationModal
            isOpen={isDeleteModalOpen}
            onClose={closeDeleteModal}
            onConfirm={handleDelete}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default ViewLab